import { useLocation } from 'react-router';

export function useOnLoginRedirectUrl(baseUrl: string) {
  const location = useLocation();
  return `${baseUrl}${location.search}`;
}
